module.exports = __webpack_public_path__ + "prod/20260903163609/img/smallProgram.e5352668.jpg";